cc.Class({
    extends: cc.Component,

    ctor () {
        this.symbols = [];
    },

    init (wildSymbols, paylines, paytables) {
        this.paylines = paylines;
        this.wildSymbols = wildSymbols;
        this.paytables = paytables;

        this.paytableMap = {};

        for (const [key, value] of Object.entries(this.paytables)) {

            const str = key.toString();
            for (let i = 0; i < value.length; i++) {
                if (value[i] > 0) {

                    this.paytableMap[str] = i + 3;
                    break;
                }
            }
          }
    },

    setPanel (panel) {
        this.panel = panel;
        this.winLength = -1;
    },

    getWinAnticipatingSymbols (lastReel) {
        if (lastReel < 1) {
            return { symbols: [], length: -1 };
        }
        this.symbols.length = 0;
        if (this.paylines) {
            this._handlePayline(lastReel);
        } else {
            this._handleWays(lastReel);
        }
        this.symbols = this.symbols.map ((data) => {
            return { reel: parseInt(data[0], 10), row: parseInt(data[1]) };
        });
        return { symbols: this.symbols, length: this.winLength };
    },

    _handlePayline (lastReel) {
        this.paylines.forEach((payline) => {
            let row = payline[0];
            let winSymbol = this.panel[0][row];
            const symbols = []
            for (let i = 0; i <= lastReel; i ++) {
                if (this.panel[i][payline[i]] === winSymbol || this.wildSymbols.includes(this.panel[i][payline[i]])) {
                    symbols.push({ reel:i, row: payline[i] });
                } else if (this.wildSymbols.includes(winSymbol) ) {
                    winSymbol = this.panel[i][payline[i]];
                    symbols.push({ reel:i, row: payline[i] });
                } else {
                    if (symbols.length < this.paytableMap[winSymbol]) {
                        symbols.length = 0;
                    }
                    break;
                }
            }

            if (symbols.length >= this.paytableMap[winSymbol]) {
                if (symbols.length > 0 ) {
                    this.winLength = Math.max(symbols.length - 1, this.winLength);
                }
                symbols.forEach((symbol) => {
                    this._addSymbol(symbol.reel, symbol.row);
                });
            }
        });
    },

    _handleWays (lastReel) {
        const length = this.panel[0].length;
        for (let row = 0; row < length; row ++) {
            const symbols = [];
            let winSymbol = this.panel[0][row];
            for (let i = 0; i <= lastReel; i ++) {
                if (this.panel[i].indexOf(winSymbol) >= 0 || this._checkTheWilds(this.panel[i])){
                    this.panel[i].forEach((symbol, row) => {
                        if (symbol === winSymbol || this.wildSymbols.includes(symbol) ) {
                            symbols.push({ reel:i, row });
                        }
                    });
                } else if (this.wildSymbols.includes(winSymbol)) {
                    winSymbol = this.panel[i][row];
                    symbols.push({ reel:i, row });
                } else {
                    if (i < this.paytableMap[winSymbol]) {
                        symbols.length = 0;
                    }
                    break;
                }
            }

            if (symbols.length > 0) {
                this.winLength = Math.max(symbols.length - 1, this.winLength);
            }
            symbols.forEach((symbol) => {
                this._addSymbol(symbol.reel, symbol.row);
            });
        }
    },

    _checkTheWilds (reel) {
        for (let i = 0; i < this.wildSymbols.length; i++) {
            if (reel.includes(this.wildSymbols[i])) {
                return true;
            }
        }
        return false;
    },

    _addSymbol (reel, row) {
        if (this.symbols.indexOf(reel + "" + row) < 0) {
            this.symbols.push(reel + "" + row);
        }
    },

    _getWinAnticipationPerSymbol (symbol) {

    }
});
